import {
  BankAccountPrefix,
  BudgetTransferKeys,
  CardTransferKeys,
  TransferKeys,
} from "@/modules/transaction/common/enum";

export const accountCommissionFieldKeys = [
  TransferKeys.Amount,
  TransferKeys.Currency,
  TransferKeys.DebitAccount,
  TransferKeys.CreditAccount,
  TransferKeys.IsUrgent,
];

export const budgetCommissionFieldKeys = [
  TransferKeys.Amount,
  TransferKeys.DebitAccount,
  BudgetTransferKeys.CreditBudgetAccount,
  TransferKeys.IsUrgent,
];

export const cardTransferCommissionFieldKeys = [
  TransferKeys.Amount,
  TransferKeys.Currency,
  TransferKeys.DebitAccount,
  CardTransferKeys.CreditCardNumber,
];

export const groupCommissionFieldKeys = [
  TransferKeys.Amount,
  TransferKeys.DebitAccount
];

export const bankNames = {
  [BankAccountPrefix.Ameria]: "bankName.ameria",
  [BankAccountPrefix.Acba]: "bankName.acba",
  [BankAccountPrefix.Amio]: "bankName.amio",
  [BankAccountPrefix.ID]: "bankName.id",
  [BankAccountPrefix.Ararat]: "bankName.ararat",
  [BankAccountPrefix.Ardshin]: "bankName.ardshin",
  [BankAccountPrefix.Armswiss]: "bankName.armswiss",
  [BankAccountPrefix.Artsakh]: "bankName.artsakh",
  [BankAccountPrefix.Byblos]: "bankName.byblos",
  [BankAccountPrefix.Evoca]: "bankName.evoca",
  [BankAccountPrefix.Ineco]: "bankName.ineco",
  [BankAccountPrefix.Convers]: "bankName.convers",
  [BankAccountPrefix.Armeconom]: "bankName.armeconom",
  [BankAccountPrefix.Mellat]: "bankName.mellat",
  [BankAccountPrefix.Uni]: "bankName.uni",
  [BankAccountPrefix.Vtb]: "bankName.vtb",
  [BankAccountPrefix.Fast]: "bankName.fast",
};
